<div class="app-user-bar">
    <a class="app-user-bell" routerLink="/admin/inqueries/index/pending" title="Préoccupations à résoudre">
        <i class="fa-regular fa-bell" aria-hidden="true"></i>
        <span class="visually-hidden">Préoccupations à résoudre</span>
    </a>

    <div class="dropdown">
        <span class="pointer dropdown-toggle app-user-chip" data-bs-toggle="dropdown" aria-expanded="false">
            <span class="app-user-avatar">{{initials()}}</span>
            <span class="app-user-identity">
                <span class="app-user-name">{{user?.name}}</span>
                <span class="app-user-role">{{roleLabel()}}</span>
            </span>
        </span>
        <ul class="dropdown-menu dropdown-menu-end">
            <li class="dropdown-header">
                <div class="fw-semibold">{{user?.name}}</div>
                <div class="small text-muted">{{user?.email}}</div>
            </li>
            <li><hr class="dropdown-divider"></li>
            <li><a class="dropdown-item pointer" (click)="logout()">
                <i class="fa-solid fa-right-from-bracket me-2" aria-hidden="true"></i>Déconnexion
            </a></li>
        </ul>
    </div>
</div>
